import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Links change impacts to the personas they affect, allowing a change impact to be associated with many personas.',
    name: 'Change Impact Personas',
    partialId: PartialId.Standard.create('change_impact_personas'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
